const BUCKETS = [
  'T1F', 'T1M', 'T2F', 'T2M', 'T3F',
  'T3M', 'T4F', 'T4M', 'T5F', 'T5M',
];

function LoadingHeadline() {
  return (
    <section aria-label="Global catalog capacity" className="mt-6 animate-pulse rounded-lg border border-gray-200 bg-white p-5">
      <div className="h-4 w-40 rounded bg-gray-200" />
      <div className="mt-4 h-8 w-64 rounded bg-gray-100" />
    </section>
  );
}

export default function CatalogCapacityHeadline({ kind, capacity, loading, error }) {
  if (loading) {
    return <LoadingHeadline />;
  }
  if (error || !capacity) {
    return (
      <section aria-label="Global catalog capacity" className="mt-6 rounded-lg border border-amber-200 bg-amber-50 px-5 py-4">
        <h2 className="text-sm font-semibold text-amber-900">Global capacity unavailable</h2>
        <p className="mt-1 text-sm text-amber-800">{error || 'Refresh the page to try again.'}</p>
      </section>
    );
  }

  if (kind === 'control') {
    return (
      <section aria-label="Global control capacity" className="mt-6 rounded-lg border border-gray-200 bg-white px-5 py-4 shadow-sm">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Global device catalog</p>
            <h2 className="mt-1 text-xl font-semibold text-gray-950">
              {capacity.enabledControlImages} enabled control images
            </h2>
            <p className="mt-1 text-sm text-gray-600">
              Across {capacity.enabledControlGroups} enabled identifier{capacity.enabledControlGroups === 1 ? '' : 's'}.
            </p>
          </div>
          <div className="rounded-md bg-emerald-50 px-4 py-3 text-right ring-1 ring-inset ring-emerald-700/10">
            <p className="text-2xl font-semibold text-emerald-800">{capacity.controlSlidesWorth}</p>
            <p className="text-xs font-medium text-emerald-700">complete 10-image slides · target 4</p>
          </div>
        </div>
      </section>
    );
  }

  const maximum = Math.max(1, ...Object.values(capacity.stimulusBuckets));
  return (
    <section aria-label="Global stimulus capacity" className="mt-6 rounded-lg border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Global device catalog</p>
          <h2 className="mt-1 text-xl font-semibold text-gray-950">
            {capacity.enabledStimuli} enabled Tanner stimuli
          </h2>
          <p className="mt-1 text-sm text-gray-600">All enabled images are sent; capacity is informational.</p>
        </div>
        <div className="rounded-md bg-emerald-50 px-4 py-3 text-right ring-1 ring-inset ring-emerald-700/10">
          <p className="text-2xl font-semibold text-emerald-800">{capacity.stimulusSlidesWorth}</p>
          <p className="text-xs font-medium text-emerald-700">balanced slides worth · target 10</p>
        </div>
      </div>
      <dl className="mt-5 grid grid-cols-5 gap-x-3 gap-y-3 sm:grid-cols-10">
        {BUCKETS.map((bucket) => {
          const count = capacity.stimulusBuckets[bucket] || 0;
          return (
            <div key={bucket}>
              <div className="flex items-baseline justify-between gap-1">
                <dt className="text-[11px] font-semibold text-gray-600">{bucket}</dt>
                <dd className="text-xs font-semibold text-gray-900">{count}</dd>
              </div>
              <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-gray-100">
                <div
                  className="h-full rounded-full bg-emerald-500"
                  style={{ width: `${(count / maximum) * 100}%` }}
                />
              </div>
            </div>
          );
        })}
      </dl>
    </section>
  );
}
